require('../../scss/pages/subpages/kontakty.scss');

/* global google, GoogleMapClass, jQuery */
(function ($) {
  let langs = {
    'SHOW_MAP': 'Zobrazit mapu poboček',
    'HIDE_MAP': 'Skrýt mapu poboček'
  }

  let mapButton = $('#show-map')
  let mapBlock = $('#contact-map')

  mapButton.on('click', e => {
    mapBlock.toggleClass('show');
    $(e.target).text(mapBlock.hasClass('show') ? langs.HIDE_MAP : langs.SHOW_MAP);
    initializeMap();
  })

  if (window.initialize && typeof window.initialize === 'function') {
    mapBlock.toggleClass('show');
    mapButton.text(mapBlock.hasClass('show') ? langs.HIDE_MAP : langs.SHOW_MAP);
    return;
  }

  // mapBlock.addClass('show')
  mapButton.text(langs.SHOW_MAP);
  let contactMap = null;

  function initializeMap() {
    if (!window.initialize) {
      window.initialize = initialize;
      contactMap = window.contactMap = new GoogleMapClass();

      $.getJSON('/kontakty/mapa-pobocek/data.json', {}, (data) => {
        contactMap.set('branches', data.items);
        contactMap.loadMapApi('initialize');
      });
    }
  }

  function initialize() {
    if (contactMap.get('instance'))
      return false;

    var infowindows = []
    var options = {
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      zoom: 7,
      scrollwheel: false
    };
    var bounds = new google.maps.LatLngBounds();
    var markers = [];

    var image = {
      url: '/sys/images/default-map-marker.png',
      // size: new google.maps.Size(250.34375, 414.15625),
      // origin: new google.maps.Point(0, 0),
      // anchor: new google.maps.Point(17, 34),
      // scaledSize: new google.maps.Size(20, 32)
    };

    contactMap.set('instance', new google.maps.Map(document.getElementById('contact-map'), options));

    contactMap.get('branches').map(branch => {

      if (!branch.latitude || !branch.longitude)
        return false;

      var marker = contactMap.drawMarker({
        icon: image,
        x: branch.latitude,
        y: branch.longitude,
        name: branch.name,
        title: branch.name,
        map: window.contactMap.getMap()
      })

      addInfoWindow(marker, branch.address)

      function addInfoWindow(marker, content) {
        var infowindow = new google.maps.InfoWindow({
          content
        });

        google.maps.event.addListener(marker, 'click', function () {
          infowindows.map(infowindow => infowindow.close())
          infowindow.open(window.contactMap.getMap(), marker);
          infowindows.push(infowindow)
        });
      }

      bounds.extend(new google.maps.LatLng(branch.latitude, branch.longitude));
      markers.push(marker);
    });

    contactMap.get('instance').setCenter(bounds.getCenter());
  }
})(jQuery);
